module.exports = __webpack_public_path__ + "media/src/images/certificates/certificate_automatic_frame-adfcc19f861b8f88eab78a4f43e88641.png";